import { str } from "@lit/localize";
//#region src/generated/locales/de.ts
var templates = {
	"pd.steps.aria.label": `Wizard-Schritte`,
	"pd.steps.aria.passed": str`Schritt ${0}: ${1} - abgeschlossen, klicken um zurückzukehren`,
	"pd.steps.aria.current": str`Schritt ${0}: ${1} - aktueller Schritt`,
	"pd.steps.aria.pending": str`Schritt ${0}: ${1} - ausstehend`,
	"pd.wizard.close.aria": `Wizard schließen`,
	"pd.wizard.button.cancel": `Abbrechen`,
	"pd.wizard.button.back": `Zurück`,
	"pd.wizard.button.next": `Weiter`,
	"pd.wizard.button.send": `Absenden`,
	"pdWizard.reload.popup.title": `Gespeicherte Daten gefunden`,
	"pdWizard.reload.popup.lastModified": `Letzte Bearbeitung:`,
	"pdWizard.reload.popup.warning": `Bei Neubeginn werden die Daten gelöscht`,
	"pdWizard.close.popup.title": `Änderungen verwerfen?`,
	"pdWizard.close.popup.storage.content": `Eingaben für später speichern oder verwerfen?`,
	"pdWizard.close.popup.noStorage.content": `Nicht gespeicherte Daten gehen verloren.`,
	"pdWizard.storage.close.popup.ok": `Speichern`,
	"pdWizard.storage.close.popup.cancel": `Verwerfen`,
	"pdWizard.close.popup.ok": `Verwerfen`,
	"pdWizard.close.popup.cancel": `Zurück`,
	"pdWizard.reload.popup.ok": `Fortsetzen`,
	"pdWizard.reload.popup.cancel": `Verwerfen`
};
//#endregion
export { templates };
